import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/style.css'
import { useAuthStore } from './stores/auth'
import axios from '@/services/axios'

// Toast Notification
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Global components
import BRKLoading from './components/BRKLoading.vue'
import BRKConfirm from './components/BRKConfirm.vue'

// Global utilities
import { decodeHtmlEntities } from './utils/stringUtils'
import { versionChecker } from './utils/versionChecker'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Setup Toast with custom options
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__fade',
  maxToasts: 5,
  newestOnTop: true
})

// Register global components
app.component('BRKLoading', BRKLoading)
app.component('BRKConfirm', BRKConfirm)

// Register global properties
app.config.globalProperties.$decodeHtml = decodeHtmlEntities

// Mount app first
app.mount('#app')

// Initialize auth store after router is ready and with a small delay
// This prevents race conditions and reduces concurrent API calls
router.isReady().then(() => {
  setTimeout(() => {
    const authStore = useAuthStore()
    authStore.initializeAuth()
  }, 100)

  // Safety check: redirect to mobile if in PWA standalone mode or on mobile device
  // This handles the race condition where display-mode: standalone wasn't ready during router init
  const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  const isMobileDevice = window.innerWidth <= 768 &&
    ('ontouchstart' in window || navigator.maxTouchPoints > 0)

  if ((isPWA || isMobileDevice) && !window.location.pathname.startsWith('/m/') && !window.location.pathname.startsWith('/intern/')) {
    console.log('📱 PWA/Mobile detected after router ready, redirecting to mobile view')
    if (isPWA) localStorage.setItem('isPWAMode', 'true')
    router.replace('/m/home')
  }

  // Listen for display-mode changes (e.g., app installed as PWA while running)
  window.matchMedia('(display-mode: standalone)').addEventListener('change', (e) => {
    if (e.matches) {
      console.log('📱 Switched to standalone mode, redirecting to mobile view')
      localStorage.setItem('isPWAMode', 'true')
      if (!window.location.pathname.startsWith('/m/')) {
        router.replace('/m/home')
      }
    }
  })

  // Initialize version checker for auto-update
  versionChecker.init()

  // ลงทะเบียน GET_TOKEN handler สำหรับ Service Worker background sync
  // ต้องอยู่ระดับ global เพื่อให้ SW ขอ token ได้จากทุกหน้า
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'GET_TOKEN') {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token')
        event.ports[0]?.postMessage({ token })
      }
    })
  }
})